import { render, staticRenderFns } from "./ServiceInfoBlock.vue?vue&type=template&id=66559efb&scoped=true&"
import script from "./ServiceInfoBlock.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoBlock.vue?vue&type=style&index=0&id=66559efb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66559efb",
  null
  
)

export default component.exports